export default {
    'export': 'Export',
    'export-as-excel': 'Export as excel file',
    'print-trial-balance': 'Print trial balance',
    'brief': '(brief)',
    'search-about-account-number-or-name': 'Account ID or name',
    'from-account': 'From account',
    'to-account': 'To account',
    'show-main-accounts': 'Show main accounts',
    'balanced-accounts-only': 'Only accounts with balance',
    'show-all-columns': 'Show all columns',
    refresh: 'Refresh',
    cancel: 'Cancel',

    'account-statement': 'Account statement',

    'sum-result-headers': {
        'debit-sum': 'Total debit',
        'credit-sum': 'Total credit',
        'debit-balance': 'Debit balance',
        'credit-balance': 'Credit balance',
    },

    'exchange-currencies-headers': {
        'difference': 'Difference',
        'equivalent-currency': 'Equivalent currency',
        'currency-equivalent-balance': 'Balance in another currency',
    },

    headers: {
        'account-no': 'Account ID',
        'account-name': 'Account name',
        'parent-account': 'Main account',
        'debit-sum': 'Total debit',
        'credit-sum': 'Total credit',
        'debit-balance': 'Debit balance',
        'credit-balance': 'Credit balance',
    },
}